function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// class MenuDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.mainDetailsToggle = this.querySelector('details');

//     this.addEventListener('keyup', this.onKeyUp.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.querySelectorAll('summary').forEach((summary) =>
//       summary.addEventListener('click', this.onSummaryClick.bind(this))
//     );
//     this.querySelectorAll(
//       'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
//     ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
//     );
//   }

//   onKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;

//     const openDetailsElement = event.target.closest('details[open]');
//     if (!openDetailsElement) return;

//     openDetailsElement === this.mainDetailsToggle
//       ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
//       : this.closeSubmenu(openDetailsElement);
//   }

//   onSummaryClick(event) {
//     const summaryElement = event.currentTarget;
//     const detailsElement = summaryElement.parentNode;
//     const parentMenuElement = detailsElement.closest('.has-submenu');
//     const isOpen = detailsElement.hasAttribute('open');
//     const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

//     function addTrapFocus() {
//       trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
//       summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
//     }

//     if (detailsElement === this.mainDetailsToggle) {
//       if (isOpen) event.preventDefault();
//       isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

//       if (window.matchMedia('(max-width: 990px)')) {
//         document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//       }
//     } else {
//       setTimeout(() => {
//         detailsElement.classList.add('menu-opening');
//         summaryElement.setAttribute('aria-expanded', true);
//         parentMenuElement && parentMenuElement.classList.add('submenu-open');
//         !reducedMotion || reducedMotion.matches
//           ? addTrapFocus()
//           : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
//       }, 100);
//     }
//   }

//   openMenuDrawer(summaryElement) {
//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });
//     summaryElement.setAttribute('aria-expanded', true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus = false) {
//     if (event === undefined) return;

//     this.mainDetailsToggle.classList.remove('menu-opening');
//     this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
//       details.removeAttribute('open');
//       details.classList.remove('menu-opening');
//     });
//     this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
//       submenu.classList.remove('submenu-open');
//     });
//     document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
//     removeTrapFocus(elementToFocus);
//     this.closeAnimation(this.mainDetailsToggle);

//     if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
//         this.closeMenuDrawer();
//     });
//   }

//   onCloseButtonClick(event) {
//     const detailsElement = event.currentTarget.closest('details');
//     this.closeSubmenu(detailsElement);
//   }

//   closeSubmenu(detailsElement) {
//     const parentMenuElement = detailsElement.closest('.submenu-open');
//     parentMenuElement && parentMenuElement.classList.remove('submenu-open');
//     detailsElement.classList.remove('menu-opening');
//     detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
//     removeTrapFocus(detailsElement.querySelector('summary'));
//     this.closeAnimation(detailsElement);
//   }

//   closeAnimation(detailsElement) {
//     let animationStart;

//     const handleAnimation = (time) => {
//       if (animationStart === undefined) {
//         animationStart = time;
//       }

//       const elapsedTime = time - animationStart;

//       if (elapsedTime < 400) {
//         window.requestAnimationFrame(handleAnimation);
//       } else {
//         detailsElement.removeAttribute('open');
//         if (detailsElement.closest('details[open]')) {
//           trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
//         }
//       }
//     };

//     window.requestAnimationFrame(handleAnimation);
//   }
// }

// customElements.define('menu-drawer', MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.querySelector('.section-header');
//     this.borderOffset =
//       this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position',
//       `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
//     );
//     this.header.classList.add('menu-open');

//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });

//     summaryElement.setAttribute('aria-expanded', true);
//     window.addEventListener('resize', this.onResize);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus) {
//     if (!elementToFocus) return;
//     super.closeMenuDrawer(event, elementToFocus);
//     this.header.classList.remove('menu-open');
//     window.removeEventListener('resize', this.onResize);
//   }

//   onResize = () => {
//     this.header &&
//       document.documentElement.style.setProperty(
//         '--header-bottom-position',
//         `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
//       );
//     document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//   };
// }

// customElements.define('header-drawer', HeaderDrawer);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        $(".sticky-header-wrapper").addClass("menu-active");
        $(".activedrawers").addClass("menu-html-active");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      $(".sticky-header-wrapper").addClass("menu-active");
      $(".activedrawers").addClass("menu-html-active");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    $(".sticky-header-wrapper").removeClass("menu-active");
    $(".activedrawers").removeClass("menu-html-active");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
      $(".sticky-header-wrapper").removeClass("menu-active");
      $(".activedrawers").removeClass("menu-html-active");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    $(".sticky-header-wrapper").removeClass("menu-active");
    $(".activedrawers").removeClass("menu-html-active");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      $(".sticky-header-wrapper").addClass("menu-active");
      $(".activedrawers").addClass("menu-html-active");
    });

    summaryElement.setAttribute("aria-expanded", true);

    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");

    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.onPurchaseOptionBound = this.onPurchaseOptionChange.bind(this);
    var packaging = localStorage.getItem("packaging");
    $(".custom-product-tab-save").find("span").hide();
    $(".custom-product-tab-save")
      .find('span[data-packname="' + packaging + '"]')
      .show();
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.syncPackSizeMobileSelect();
      this.updatePackSizeCardPrices();
      this.syncDeliveryFrequencyVisibility();
    });
    document.addEventListener("change", this.onPurchaseOptionBound);
  }

  disconnectedCallback() {
    document.removeEventListener("change", this.onPurchaseOptionBound);
  }

  /** Hide delivery frequency when one-time purchase is selected (same product-info). */
  syncDeliveryFrequencyVisibility() {
    const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (!info) return;
    const field = info.querySelector(".delivery-frequency-field");
    if (!field) return;
    const subscriptionOn = Boolean(
      info.querySelector(
        'input[name="purchaseOption"][value="subscription"]:checked'
      )
    );
    field.style.display = subscriptionOn ? "" : "none";
  }

  onPurchaseOptionChange(event) {
    if (!event.target || event.target.name !== "purchaseOption") return;
    const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (!info || !info.contains(event.target)) return;
    this.updatePackSizeCardPrices();
    this.syncDeliveryFrequencyVisibility();
  }

  onVariantChange(event) {
    // Selling plan lives inside <variant-selects> but is not a variant dimension;
    // handling it here corrupts this.options and breaks pack size / variant matching.
    if (VariantSelects.isDeliveryFrequencySelect(event.target)) {
      this.updatePackSizeCardPrices();
      return;
    }
    if (VariantSelects.isPackSizeMobileSyncSelect(event.target)) {
      const fs = this.querySelector(".product-form__input--pack-size");
      const input = fs
        ? Array.from(
            fs.querySelectorAll(
              '.variant-label-container--pack-size input[type="radio"]'
            )
          ).find((r) => r.value === event.target.value)
        : null;
      if (input) input.checked = true;
    }
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    if (this.currentVariant) {
      if (this.currentVariant.name.indexOf("Custom Bundle") == -1) {
        this.toggleAddButton(true, "", false);
      }
    }

    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updatePackSizeCardPrices();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    
    this.updateCustomBundleVariants();

    this.syncPackSizeMobileSelect();
  }

  updateCustomBundleVariants() {
    const customBundle = document.querySelector('.custom-product-bundle-title');
    if (customBundle) {
      const productSwatchInputElement = document.querySelector('.product-form__input--swatch input:checked');
      if (productSwatchInputElement?.value) {
        const productOptionElements = document.querySelectorAll(`.product-bundle-product-checkbox[data-available-${productSwatchInputElement.value.toLowerCase()}]`);
        if (productOptionElements.length > 0) {
          productOptionElements.forEach((productOptionElement) => {
            const productsAvailable = productOptionElement.dataset[`available${productSwatchInputElement.value}`];
            const productsAvailableQuantity = parseInt(productsAvailable)
            if (productsAvailableQuantity > 0) {
              productOptionElement.parentElement.style.display = 'unset';
            } else {
              productOptionElement.parentElement.style.display = 'none';
            }
          });
        }
      }
      const removeProductElement = document.querySelector('.remove-product');
      if (removeProductElement) {
        removeProductElement.click();
        removeProductElement.click();
        removeProductElement.click();
      }
    }
  }

  updateOptions() {
    this.options = [];
    this.querySelectorAll("select, fieldset").forEach((element) => {
      if (element.tagName === "SELECT") {
        if (VariantSelects.isDeliveryFrequencySelect(element)) return;
        if (VariantSelects.isPackSizeMobileSyncSelect(element)) return;
        this.options.push(element.value);
        return;
      }
      if (element.tagName === "FIELDSET") {
        const checked = Array.from(element.querySelectorAll("input")).find(
          (radio) => radio.checked
        );
        if (checked) this.options.push(checked.value);
      }
    });
  }

  static isDeliveryFrequencySelect(el) {
    return (
      el &&
      el.tagName === "SELECT" &&
      (el.name === "selling_plan" ||
        el.classList.contains("input-sellingplan") ||
        Boolean(el.closest(".delivery-frequency-field")))
    );
  }

  /** Native <select> UI for pack size on mobile; radios remain the form source of truth. */
  static isPackSizeMobileSyncSelect(el) {
    return (
      el &&
      el.tagName === "SELECT" &&
      el.hasAttribute("data-pack-size-mobile-sync")
    );
  }

  syncPackSizeMobileSelect() {
    const sel = this.querySelector("select[data-pack-size-mobile-sync]");
    if (!sel) return;
    const fs = this.querySelector(".product-form__input--pack-size");
    if (!fs) return;
    const checked = fs.querySelector(
      '.variant-label-container--pack-size input[type="radio"]:checked'
    );
    if (!checked) return;
    const hasMatchingOption = Array.from(sel.options).some(
      (o) => o.value === checked.value
    );
    if (!hasMatchingOption) return;
    if (sel.value !== checked.value) sel.value = checked.value;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    var index = $(
      '.custom-product-gallery-slider .swiper-slide[data-mediaid="' +
        this.currentVariant.featured_media.id +
        '"]'
    ).data("index");

    var evt = new CustomEvent("ChangeMedia", { detail: index });
    window.dispatchEvent(evt);

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    if (this.currentVariant.name.indexOf("Custom Bundle") != -1) {
      return;
    }
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    var inputvarname = this.currentVariant.name;
    var inputvarpart = inputvarname.split(" / ");
    var inputvariablevalue = inputvarpart[inputvarpart.length - 1];
    localStorage.setItem("packaging", inputvariablevalue);

    $(".custom-product-tab-save").find("span").hide();
    $(".custom-product-tab-save")
      .find('span[data-packname="' + inputvariablevalue + '"]')
      .show();

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const section = this.closest("section");

    const $ctaSync = $(section).find(".subscription-checkout-cta");
    if ($ctaSync.length) {
      $ctaSync.attr(
        "data-bag-multiplier",
        String(hamptonBagMultiplierFromVariant(this.currentVariant))
      );
    }
    const $otpCheckout = $(section).find(".try-them-all-otp-checkout");
    if ($otpCheckout.length) {
      const vSyn = this.currentVariant;
      $otpCheckout.attr(
        "data-bag-multiplier",
        String(hamptonBagMultiplierFromVariant(vSyn))
      );
      hamptonTryThemAllOtpPriceUpdate(section, vSyn);
    }
    const allocations = this.currentVariant.selling_plan_allocations || [];
    if (allocations.length > 0) {
        const $freqSel = $(section).find(
          "select.input-sellingplan, select[name='selling_plan']"
        );
        const allocIds = allocations.map((a) => String(a.selling_plan_id));
        const formatSellingPlanLabel = (name) => {
          if (name == null || name === "") return "";
          const s = String(name).trim().toLowerCase();
          const stripped = s.replace(/^delivery\s+every\s*/g, "every ");
          return stripped.replace(/\s+/g, " ").trim().toUpperCase();
        };

        if ($freqSel.length) {
          const existingIds = $freqSel
            .find("option")
            .map(function () {
              return String(this.value);
            })
            .get();
          const needsRebuild =
            existingIds.length !== allocIds.length ||
            allocIds.some((id) => !existingIds.includes(id));

          if (needsRebuild) {
            const prevVal = String($freqSel.val() || "");
            const labelByPlanId = {};
            $freqSel.find("option").each(function () {
              labelByPlanId[String(this.value)] = ($(this).text() || "").trim();
            });
            const labelMap = this.getSellingPlanLabelMap();
            $freqSel.empty();
            allocations.forEach((plan) => {
              const id = String(
                plan.selling_plan_id != null
                  ? plan.selling_plan_id
                  : plan.selling_plan && plan.selling_plan.id
              );
              const nameFromJson =
                plan.selling_plan && plan.selling_plan.name;
              let label = formatSellingPlanLabel(nameFromJson || "");
              if (!label) label = formatSellingPlanLabel(labelByPlanId[id] || "");
              if (!label) {
                label = formatSellingPlanLabel(
                  labelMap[id] != null ? String(labelMap[id]) : ""
                );
              }
              if (!label) label = "DELIVERY OPTION";
              const cmp =
                plan.compare_at_price != null && plan.compare_at_price !== ""
                  ? plan.compare_at_price
                  : "";
              $("<option></option>")
                .attr("value", id)
                .attr("data-sellingplan", id)
                .attr("data-price", plan.price)
                .attr("data-compare-price", cmp)
                .text(label)
                .appendTo($freqSel);
            });
            const keep =
              prevVal && allocIds.includes(prevVal) ? prevVal : allocIds[0];
            $freqSel.val(keep);
          }
        }

        allocations.forEach(function (plan) {
          const cmp =
            plan.compare_at_price != null && plan.compare_at_price !== ""
              ? plan.compare_at_price
              : "";
          $(section)
            .find(
              'option[data-sellingplan="' +
                plan.selling_plan_id +
                '"], .input-sellingplan[data-sellingplan="' +
                plan.selling_plan_id +
                '"]'
            )
            .attr("data-price", plan.price)
            .attr("data-compare-price", cmp);
        });

        if ($freqSel.length && allocations.length) {
          const curVal = String($freqSel.val() || "");
          if (curVal && !allocIds.includes(curVal)) {
            $freqSel.val(allocIds[0]);
          }
        }

        if ($freqSel.length) {
          hamptonSellingPlanFrequencySelectApplySingle($freqSel.get(0));
        }

        let subprice;
        let subcompprice;
        if ($freqSel.length) {
          const $opt = $freqSel.find("option:selected");
          subprice = $opt.attr("data-price");
          subcompprice = $opt.attr("data-compare-price");
        } else {
          subprice = $(section)
            .find(".input-sellingplan:checked")
            .attr("data-price");
          subcompprice = $(section)
            .find(".input-sellingplan:checked")
            .attr("data-compare-price");
        }
        if (subprice) {
          let subHtml = Shopify.formatMoney(subprice);
          if (subcompprice) {
            subHtml += `<s>${Shopify.formatMoney(subcompprice)}</s>`;
          }
          $(section).find(".subscriptionprice").html(subHtml);
          hamptonSubscriptionCheckoutCtaSetSub(
            $(section),
            subprice,
            subcompprice
          );
        }
    }
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      $(section)
        .find(".onetimeprice")
        .html(
          `${Shopify.formatMoney(
            this.currentVariant.price
          )}<s>${Shopify.formatMoney(
            this.currentVariant.compare_at_price
          )}</s>`
        );
    } else {
      $(section)
        .find(".onetimeprice")
        .html(`${Shopify.formatMoney(this.currentVariant.price)}`);
    }
    hamptonSubscriptionCheckoutCtaSetOnetime(
      $(section),
      this.currentVariant.price
    );
    if (this.currentVariant?.featured_image?.product_id == 6998189309987) {
      $(section)
        .find(".subscriptionprice")
        .html(
          `${Shopify.formatMoney(
            this.currentVariant.price
          )}<s>${Shopify.formatMoney(this.currentVariant.compare_at_price)}</s>`
        );
    }

    this.updatePackSizeCardPrices();

    if (this.currentVariant.name.indexOf("Custom Bundle") != -1) {
      return;
    }
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const subCta = addButton.closest(".subscription-checkout-cta");

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text && addButtonText && !subCta) {
        addButtonText.textContent = text;
      }
      if (text && subCta) {
        subCta.classList.add("subscription-checkout-cta--sold-out");
      }
    } else {
      addButton.removeAttribute("disabled");
      if (subCta) {
        subCta.classList.remove("subscription-checkout-cta--sold-out");
        subCta.classList.remove("subscription-checkout-cta--unavailable");
      } else if (addButtonText) {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    const subCta = addButton.closest(".subscription-checkout-cta");
    if (subCta) {
      subCta.classList.add("subscription-checkout-cta--unavailable");
    } else if (addButtonText) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  updatePackSizeCardPrices() {
    const packFieldset = this.querySelector(".product-form__input--pack-size");
    if (!packFieldset) return;
    const sizeIdx = parseInt(
      packFieldset.dataset.packSizeOptionIndex || "-1",
      10
    );
    if (Number.isNaN(sizeIdx) || sizeIdx < 0) return;
    const variantData = this.getVariantData();
    if (!variantData || !variantData.length) return;
    const productInfo = document.getElementById(
      `ProductInfo-${this.dataset.section}`
    );
    const hasPurchaseOption = Boolean(
      productInfo?.querySelector('input[name="purchaseOption"]')
    );
    const cta = productInfo?.querySelector(".subscription-checkout-cta");
    const ctaOnetime = cta?.classList.contains(
      "subscription-checkout-cta--onetime"
    );
    let subscribeMode = false;
    if (ctaOnetime) {
      subscribeMode = false;
    } else if (hasPurchaseOption) {
      const po = productInfo.querySelector(
        'input[name="purchaseOption"]:checked'
      );
      if (po) {
        subscribeMode = po.value === "subscription";
      } else {
        subscribeMode =
          packFieldset.dataset.packInitialSubscribe === "true";
      }
    } else {
      subscribeMode =
        packFieldset.dataset.packInitialSubscribe === "true";
    }
    let discountPct = parseInt(
      packFieldset.dataset.packSubscribeDiscount || "20",
      10
    );
    if (Number.isNaN(discountPct) || discountPct < 0) discountPct = 20;
    if (discountPct > 100) discountPct = 100;

    let selectedPlanId = "";
    if (productInfo) {
      const spSel = productInfo.querySelector(
        'select[name="selling_plan"]'
      );
      if (spSel && spSel.value) selectedPlanId = String(spSel.value);
      if (!selectedPlanId) {
        const spIn = productInfo.querySelector(
          'input[name="selling_plan"]:checked:not(:disabled)'
        );
        if (spIn && spIn.value) selectedPlanId = String(spIn.value);
      }
    }

    this.updateOptions();
    const base = [...this.options];
    packFieldset
      .querySelectorAll(
        '.variant-label-container--pack-size input[type="radio"]'
      )
      .forEach((input) => {
        const label = input.nextElementSibling;
        if (!label || !label.classList.contains("pack-size-card")) return;
        const opts = [...base];
        opts[sizeIdx] = input.value;
        const variant = variantData.find((v) =>
          v.options.every((o, i) => o === opts[i])
        );
        const cur = label.querySelector(".pack-size-card__current");
        const cmp = label.querySelector(".pack-size-card__compare");
        if (!cur) return;
        if (!variant) {
          cur.textContent = "";
          if (cmp) {
            cmp.textContent = "";
            cmp.setAttribute("hidden", "");
          }
          return;
        }
        if (subscribeMode) {
          const allocs = variant.selling_plan_allocations || [];
          let subCents = 0;
          let compareCents = 0;
          if (allocs.length > 0) {
            let plan = null;
            if (selectedPlanId) {
              plan = allocs.find((a) => {
                const id =
                  a.selling_plan_id != null
                    ? String(a.selling_plan_id)
                    : a.selling_plan && a.selling_plan.id != null
                      ? String(a.selling_plan.id)
                      : "";
                return id && id === selectedPlanId;
              });
            }
            if (!plan) plan = allocs[0];
            subCents = parseInt(String(plan.price), 10) || 0;
            const rawCmp = plan.compare_at_price;
            if (rawCmp != null && rawCmp !== "") {
              compareCents = parseInt(String(rawCmp), 10) || 0;
            }
          } else {
            const price = variant.price;
            const compareAt = variant.compare_at_price || 0;
            const anchor = compareAt > price ? compareAt : price;
            compareCents = anchor;
            subCents = Math.floor(
              (anchor * (100 - discountPct)) / 100
            );
          }
          cur.textContent = Shopify.formatMoney(subCents);
          if (cmp) {
            if (compareCents > subCents) {
              cmp.textContent = Shopify.formatMoney(compareCents);
              cmp.removeAttribute("hidden");
            } else {
              cmp.textContent = "";
              cmp.setAttribute("hidden", "");
            }
          }
        } else {
          cur.textContent = Shopify.formatMoney(variant.price);
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            if (cmp) {
              cmp.textContent = Shopify.formatMoney(
                variant.compare_at_price
              );
              cmp.removeAttribute("hidden");
            }
          } else if (cmp) {
            cmp.textContent = "";
            cmp.setAttribute("hidden", "");
          }
        }
      });
    this.updatePackSizeMobileFace();
  }

  /** Mirrors desktop pack card line (title + optional compare + price) and TRY IT / MOST POPULAR on mobile composite select. */
  updatePackSizeMobileFace() {
    const fs = this.querySelector(".product-form__input--pack-size");
    if (!fs) return;
    const primaryEl = fs.querySelector(".pack-size-mobile__primary");
    const badgeEl = fs.querySelector(".pack-size-mobile__badge");
    if (!primaryEl || !badgeEl) return;

    const input = fs.querySelector(
      '.variant-label-container--pack-size input[type="radio"]:checked'
    );
    if (!input) {
      primaryEl.textContent = "";
      badgeEl.textContent = "";
      badgeEl.hidden = true;
      badgeEl.className = "pack-size-mobile__badge";
      return;
    }

    const label = input.nextElementSibling;
    if (!label || !label.classList.contains("pack-size-card")) {
      primaryEl.textContent = "";
      badgeEl.textContent = "";
      badgeEl.hidden = true;
      badgeEl.className = "pack-size-mobile__badge";
      return;
    }

    const titleEl = label.querySelector(".pack-size-card__title");
    const cur = label.querySelector(".pack-size-card__current");
    const title = titleEl?.textContent?.trim() || "";
    const price = cur?.textContent?.trim() || "";

    primaryEl.replaceChildren();
    if (!title || !price) {
      badgeEl.textContent = "";
      badgeEl.hidden = true;
      badgeEl.className = "pack-size-mobile__badge";
      return;
    }

    primaryEl.appendChild(
      document.createTextNode(`${title} - ${price}`)
    );

    badgeEl.textContent = "";
    badgeEl.hidden = true;

    const tryTag = label.querySelector(".pack-size-card__tag--try");
    const popularTag = label.querySelector(".pack-size-card__tag--popular");

    if (popularTag?.textContent?.trim()) {
      badgeEl.hidden = false;
      badgeEl.className =
        "pack-size-mobile__badge pack-size-mobile__badge--popular";
      badgeEl.textContent = popularTag.textContent.trim();
    } else if (tryTag?.textContent?.trim()) {
      badgeEl.hidden = false;
      badgeEl.className = "pack-size-mobile__badge pack-size-mobile__badge--try";
      badgeEl.textContent = tryTag.textContent.trim();
    } else {
      badgeEl.className = "pack-size-mobile__badge";
    }
  }

  getVariantData() {
    if (this.variantData) return this.variantData;
    const script =
      this.querySelector(
        'script[type="application/json"][data-variant-data]'
      ) ||
      this.querySelector(
        'script[type="application/json"]:not([data-selling-plan-labels])'
      );
    if (!script) return [];
    this.variantData = JSON.parse(script.textContent);
    return this.variantData;
  }

  /** selling_plan_id -> display label (Liquid); variant | json omits plan names on allocations. */
  getSellingPlanLabelMap() {
    if (this._sellingPlanLabelMap) return this._sellingPlanLabelMap;
    const el = this.querySelector(
      'script[type="application/json"][data-selling-plan-labels]'
    );
    if (!el || !el.textContent.trim()) {
      this._sellingPlanLabelMap = {};
      return this._sellingPlanLabelMap;
    }
    try {
      this._sellingPlanLabelMap = JSON.parse(el.textContent);
    } catch (e) {
      this._sellingPlanLabelMap = {};
    }
    return this._sellingPlanLabelMap;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CustomHeaderMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".header__menu-item").mouseenter(function () {
        var index = $(this).data("index");
        console.log("heyyy==" + index);
        $(".mega-menu__content").removeClass("activemega");
        $(".sticky-header .header").removeClass("header-new");
        $(".header__menu-item").removeClass("activenav");
        $(".mega-menu__content[data-index='" + index + "']").addClass(
          "activemega"
        );
        $(".header__menu-item")
          .parents()
          .parents()
          .parents("header")
          .addClass("header-new");
        $(".header__menu-item[data-index='" + index + "']").addClass(
          "activenav"
        );
      });

      $(".mega-menu__content").mouseenter(function () {
        var index = $(this).data("index");
        console.log("heyyy==" + index);
        $(".mega-menu__content").removeClass("activemega");
        $(".sticky-header .header").removeClass("header-new");
        $(".header__menu-item").removeClass("activenav");
        $(".mega-menu__content[data-index='" + index + "']").addClass(
          "activemega"
        );
        $(".header__menu-item[data-index='" + index + "']").addClass(
          "activenav"
        );
        $(".header__menu-item")
          .parents()
          .parents()
          .parents("header")
          .addClass("header-new");
      });

      var firstDiv = $(".header__menu-item");
      var secondDiv = $(".mega-menu__content");
      $(document).on("mouseover", function (e) {
        if (
          !firstDiv.is(e.target) &&
          firstDiv.has(e.target).length === 0 &&
          !secondDiv.is(e.target) &&
          secondDiv.has(e.target).length === 0
        ) {
          $(".mega-menu__content").removeClass("activemega");
          $(".sticky-header .header").removeClass("header-new");
          $(".header__menu-item").removeClass("activenav");
          $(".header__menu-item")
            .parents()
            .parents()
            .parents("header")
            .addClass("header-new");
        }
      });

      $(".menu-drawer__menu-item-cart")
        .unbind()
        .click(function () {
          $(".cart-drawer-container").addClass("active");
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-header-menu", CustomHeaderMenu);

let items = document.querySelector(".header__inline-menu")?.querySelectorAll("details");
let dropdownItems = document.querySelector(".header-wrapper");
items?.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    $("sticky-header").addClass("opened");
    item.setAttribute("open", true);
    let ulElement = item.querySelector("ul");
    if (ulElement !== null) {
      ulElement.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    }
  });
  item.addEventListener("focus", () => {
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", "");
  });
});

if (dropdownItems !== null) {
  dropdownItems.addEventListener("mouseleave", () => {
    items.forEach((item) => {
      $("sticky-header").removeClass("opened");
      item.removeAttribute("open");
    });
  });
}

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".custom-card-main").find(".faq-answers").removeClass("show");
            $(".custom-card-main").find(".faq-answers").slideUp(350);
            $(".custom-card-main").removeClass("active");

            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
          // if ($this.parent().hasClass('active')) {
          //     $this.parent().removeClass('active');
          // } else {
          //     $('.custom-card-main').find('.custom-card-main').removeClass('active');
          //     $this.parent().toggleClass('active');
          // }
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class testimonialslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".testimonial-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.2,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next-button",
            prevEl: ".swiper-button-prev-button",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("testimonial-slider", testimonialslider);

class CustomMainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const initGallery = () => {
      if (this.__customMainProductGalleryInited) return;

      const sectionId = this.getAttribute("data-sectionid");
      const topEl = this.querySelector(
        ".custom-product-gallery-slider-" + sectionId
      );
      if (!topEl || !topEl.querySelector(".swiper-slide")) return;
      if (topEl.classList.contains("swiper-initialized")) return;

      const thumbEl = this.querySelector(
        ".custom-product-gallery-thumbnail-" + sectionId
      );
      const prevBtn = this.querySelector(".custom-product-gallery__thumb-prev");
      const nextBtn = this.querySelector(".custom-product-gallery__thumb-next");

      let galleryThumbsnew = null;
      try {
        if (thumbEl && thumbEl.querySelector(".swiper-slide")) {
          galleryThumbsnew = new Swiper(thumbEl, {
            spaceBetween: 8,
            slidesPerView: 4,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            breakpoints: {
              768: {
                slidesPerView: 4,
                spaceBetween: 8,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            },
          });
        }

        const topOptions = {
          spaceBetween: 10,
          slidesPerView: 1,
          watchOverflow: true,
          touchStartPreventDefault: false,
          preventClicks: false,
          preventClicksPropagation: false,
        };
        if (galleryThumbsnew) {
          topOptions.thumbs = { swiper: galleryThumbsnew };
        }
        if (prevBtn && nextBtn) {
          topOptions.navigation = {
            nextEl: nextBtn,
            prevEl: prevBtn,
          };
        }

        var galleryTopnew = new Swiper(topEl, topOptions);

        if (galleryThumbsnew) {
          galleryTopnew.on("slideChangeTransitionStart", function () {
            galleryThumbsnew.slideTo(galleryTopnew.activeIndex);
          });
        }

        window.addEventListener(
          "ChangeMedia",
          function (evt) {
            const n = Number(evt.detail);
            if (!Number.isFinite(n) || n < 1) return;
            galleryTopnew.slideTo(n - 1);
          },
          false
        );
        var cmediaid = $(this).data("cmedia");
        if (cmediaid != "none") {
          var slideEl = topEl.querySelector(
            '.swiper-slide[data-mediaid="' + cmediaid + '"]'
          );
          var idx = slideEl ? slideEl.getAttribute("data-index") : null;
          if (idx != null && idx !== "") {
            const start = Number(idx);
            if (Number.isFinite(start) && start >= 1) {
              galleryTopnew.slideTo(start - 1);
            }
          }
        }

        this.__customMainProductGalleryInited = true;
      } catch (e) {
        console.warn("[custom-main-product] gallery init failed", e);
      }
    };

    const schedule =
      typeof window.Swiper === "undefined"
        ? (fn) => window.addEventListener("load", fn, { once: true })
        : (fn) =>
            requestAnimationFrame(() => requestAnimationFrame(fn));

    schedule(() => initGallery.call(this));
  }
}

customElements.define("custom-main-product", CustomMainProduct);

class customtestimonial extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".custom-testimonial--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 40,
          navigation: {
            nextEl: ".swiper-button-next-button",
            prevEl: ".swiper-button-prev-button",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            990: {
              slidesPerView: 2,
              spaceBetween: 36,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-testimonial", customtestimonial);

class CustomAnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".announcementbar-swiper-" + this.getAttribute("data-sectionid"),
        {
          spaceBetween: 0,
          slidesPerView: "auto",
          loop: true,
          speed: 5000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-announcement-bar", CustomAnnouncementBar);

function hamptonPackLabelFromVariant(variant) {
  if (!variant) return "";
  const parts = [variant.option1, variant.option2, variant.option3].filter(
    function (x) {
      return x != null && String(x).trim() !== "";
    }
  );
  let s = parts.join(" ").trim().toLowerCase();
  s = s.replace(/-pack/g, " bags").replace(/pack/g, "bags");
  return s.replace(/\s+/g, " ").trim().toUpperCase();
}

function hamptonBagMultiplierFromVariant(variant) {
  const label = hamptonPackLabelFromVariant(variant);
  if (!label) return 1;
  if (label.includes("6 BAG")) return 6;
  if (label.includes("4 BAG")) return 4;
  if (label.includes("3 BAG")) return 3;
  if (label.includes("2 BAG")) return 2;
  if (label.includes("1 WEEK SUPPLY")) return 2;
  if (label.includes("2 WEEK SUPPLY")) return 4;
  if (label.includes("1 MONTH SUPPLY")) return 8;
  if (label.includes("SINGLE") || label.includes("1 BAG")) return 1;
  return 1;
}

function hamptonSubscriptionCheckoutCtaTotalServings($cta) {
  const perBag =
    parseInt($cta.attr("data-servings-per-bag") || "0", 10) || 0;
  const mult =
    parseInt($cta.attr("data-bag-multiplier") || "1", 10) || 1;
  if (perBag > 0) {
    return perBag * mult;
  }
  return parseInt($cta.attr("data-servings") || "0", 10) || 0;
}

/** Try-them-all OTP row (hero price + PER SERVING); uses same data-* attrs as subscription CTA for serving math. */
function hamptonTryThemAllOtpPriceUpdate(sectionEl, variant) {
  const $otp = $(sectionEl).find(".try-them-all-otp-checkout");
  if (!$otp.length || !variant) return;
  const priceCents = parseInt(String(variant.price), 10) || 0;
  $otp
    .find(".try-them-all-otp-checkout__hero-inner")
    .text(Shopify.formatMoney(variant.price));
  const $per = $otp.find(".try-them-all-otp-checkout__per");
  const servingsTotal = hamptonSubscriptionCheckoutCtaTotalServings($otp);
  if (servingsTotal > 0 && priceCents > 0) {
    const perCents = Math.floor(priceCents / servingsTotal);
    $per.text(
      Shopify.formatMoney(perCents) +
        " PER SERVING (" +
        servingsTotal +
        " SERVINGS)"
    );
  } else {
    $per.empty();
  }
}

function hamptonSubscriptionCheckoutCtaSetSub($root, subprice, subcompprice) {
  const $cta = $root.find(".subscription-checkout-cta");
  if (!$cta.length || !subprice) return;
  const servings = hamptonSubscriptionCheckoutCtaTotalServings($cta);
  const subNum = parseInt(String(subprice), 10);
  $cta
    .find(".subscription-checkout-cta__hero-amount")
    .text(Shopify.formatMoney(subprice));
  const $hc = $cta.find(".subscription-checkout-cta__hero-compare");
  const compNum = subcompprice ? parseInt(String(subcompprice), 10) : 0;
  if (compNum > subNum) {
    $hc.html("<s>" + Shopify.formatMoney(subcompprice) + "</s>");
    $hc.removeClass("hidden subscription-checkout-cta__hero-compare--empty");
  } else {
    $hc.empty();
    $hc.addClass("hidden subscription-checkout-cta__hero-compare--empty");
  }
  const $per = $cta.find(".subscription-checkout-cta__hero-per");
  if (servings > 0 && subNum) {
    $per
      .text(
        Shopify.formatMoney(Math.round(subNum / servings)) + " PER SERVING"
      )
      .removeClass("hidden");
  } else {
    $per.empty().addClass("hidden");
  }
  $cta
    .find(".subscription-checkout-cta__btn-sub-amount")
    .text(Shopify.formatMoney(subprice));
}

function hamptonSubscriptionCheckoutCtaSetOnetime($root, priceCents) {
  const $cta = $root.find(".subscription-checkout-cta");
  if (!$cta.length) return;
  const servings = hamptonSubscriptionCheckoutCtaTotalServings($cta);
  const ot = parseInt(String(priceCents), 10);
  $cta
    .find(".subscription-checkout-cta__once-money")
    .text(Shopify.formatMoney(priceCents));
  if (servings > 0 && ot) {
    $cta
      .find(".subscription-checkout-cta__once-per")
      .text(Shopify.formatMoney(Math.round(ot / servings)));
  }
}

/** Subscribe + visible frequency field: one allocation → block interaction without disabling the select (inert wrapper). */
function hamptonSellingPlanFrequencySelectApplySingle(planSelect) {
  if (
    !planSelect ||
    planSelect.tagName !== "SELECT" ||
    planSelect.name !== "selling_plan"
  ) {
    return;
  }
  const $el = $(planSelect);
  const $info = $el.closest("product-info");
  if (!$info.length) return;
  if (
    !$info.find(
      'input[name="purchaseOption"][value="subscription"]:checked'
    ).length
  ) {
    return;
  }
  const $freq = $el.closest(".delivery-frequency-field");
  if (!$freq.length || !$freq.is(":visible")) return;
  const n = planSelect.options ? planSelect.options.length : 0;
  const single = n <= 1;
  const wrap = planSelect.closest(".delivery-frequency-field__select-wrap");
  if (!wrap) return;
  if (single) wrap.setAttribute("inert", "");
  else wrap.removeAttribute("inert");
  wrap.classList.toggle("delivery-frequency-field__select-wrap--single", single);
  planSelect.classList.toggle("delivery-frequency-field__select--single", single);
}

$(document).ready(function () {
  // Check the first input box by default
  $(".option-item input:first").prop("checked", true);

  $(".rc_container_wrapper").remove();

  $(".rc-radio__input").change(function () {
    const $info = $(this).closest("product-info");
    const $root = $info.length ? $info : $(document);
    if ($(this).val() == "subscription") {
      $root.find('select[name="selling_plan"]').prop("disabled", false);
      $root.find('input[name="selling_plan"]').prop("disabled", false);
      $root.find('select[name="selling_plan"]').each(function () {
        hamptonSellingPlanFrequencySelectApplySingle(this);
      });
      $root.find(".delivery-options").css("display", "flex");
      $root.find(".delivery-frequency-field").css("display", "");
    } else {
      $root
        .find('select[name="selling_plan"], input[name="selling_plan"]')
        .prop("disabled", true);
      $root.find(".delivery-options").css("display", "none");
      $root.find(".delivery-frequency-field").css("display", "none");
    }
    $root.find(".subscription-checkout-cta").toggleClass(
      "subscription-checkout-cta--onetime",
      $(this).val() !== "subscription"
    );
  });

  $("product-info").each(function () {
    const onetime = $(this).find(
      'input[name="purchaseOption"][value="onetime"]:checked'
    ).length;
    $(this)
      .find(".subscription-checkout-cta")
      .toggleClass("subscription-checkout-cta--onetime", Boolean(onetime));
    $(this)
      .find('select[name="selling_plan"]')
      .each(function () {
        hamptonSellingPlanFrequencySelectApplySingle(this);
      });
  });

  $(document).on("click", ".subscription-checkout-cta__buy-once", function (
    e
  ) {
    e.preventDefault();
    const $info = $(this).closest("product-info");
    if (!$info.length) return;
    $info
      .find('input[name="purchaseOption"][value="onetime"]')
      .first()
      .prop("checked", true)
      .trigger("change");
    window.setTimeout(() => {
      const btn = $info
        .find('product-form button[type="submit"][name="add"]')
        .get(0);
      if (!btn || btn.disabled || btn.getAttribute("aria-disabled") === "true") {
        return;
      }
      btn.click();
    }, 0);
  });

  $(document).on(
    "change",
    "select.input-sellingplan, select[name='selling_plan']",
    function () {
      const $opt = $(this).find("option:selected");
      const subprice = $opt.attr("data-price");
      const subcomp = $opt.attr("data-compare-price");
      const $info = $(this).closest("product-info");
      if (!subprice || !$info.length) return;
      const priceHtml = subcomp
        ? `${Shopify.formatMoney(subprice)}<s>${Shopify.formatMoney(
            subcomp
          )}</s>`
        : Shopify.formatMoney(subprice);
      $info.find(".subscriptionprice").html(priceHtml);
      hamptonSubscriptionCheckoutCtaSetSub($info, subprice, subcomp);
      const vs = $info.find("variant-selects").get(0);
      if (vs && typeof vs.updatePackSizeCardPrices === "function") {
        vs.updatePackSizeCardPrices();
      }
    }
  );
});
$(window).on("load", function () {
  $(".rc_container_wrapper").remove();
  setTimeout(function () {
    $("select.input-sellingplan, select[name='selling_plan']").each(
      function () {
        const $s = $(this);
        const $opt = $s.find("option:selected");
        if ($opt.length && $opt.attr("data-sellingplan")) {
          $s.val($opt.val());
        }
        hamptonSellingPlanFrequencySelectApplySingle(this);
      }
    );
    $(".rc_container_wrapper").remove();
  }, 2000);
});

// class Footer extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//       $(".clickdrawercontact")
//         .unbind()
//         .click(function () {
//           $(".contact-drawer-container").addClass("animate active");
//           $("body").css({ overflow: "hidden" });
//           $('body').removeClass('bodyoverflow')
//           $('html').removeClass('bodyoverflow')

//         });

//       $(".contact-drawer__overlay")
//         .unbind()
//         .click(function () {
//           $("body").css({ overflow: "visible" });
//           $('body').addClass('bodyoverflow')
//           $('html').addClass('bodyoverflow')

//         });

//       $(".drawer__close")
//         .unbind()
//         .click(function () {
//           $("body").css({ overflow: "visible" });
//           $('body').addClass('bodyoverflow')
//           $('html').addClass('bodyoverflow')

//         });
//     };
//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }
// customElements.define("footer", Footer);

// class Customcontact extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//       $(".clickdrawercontact")
//         .unbind()
//         .click(function () {
//           $(".contact-drawer-container").addClass("animate active");
//           $("body").css({ overflow: "hidden" });
//           $('body').removeClass('bodyoverflow')
//           $('html').removeClass('bodyoverflow')

//         });

//       $(".contact-drawer__overlay")
//         .unbind()
//         .click(function () {
//           $("body").css({ overflow: "visible" });
//           $('body').addClass('bodyoverflow')
//           $('html').addClass('bodyoverflow')
//         });

//       $(".drawer__close")
//         .unbind()
//         .click(function () {
//           $("body").css({ overflow: "visible" });
//           $('body').addClass('bodyoverflow')
//           $('html').addClass('bodyoverflow')

//         });
//     };
//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }
// customElements.define("custom-contact", Customcontact);

$(document).ready(function () {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get("viewcart");
  console.log(c);
  if (c == "true") {
    console.log(c);
   $(".cart-drawer-container").addClass("active");
  }
});
